import { Link } from "react-router-dom";
import { formatLabDate, formatLabTimeRange } from "../utils/datetime";

function UpcomingLabs({
  labs,
  isLoading,
  error,
  onRegisterClick,
  registerButtonLabel = "Register free for this Lab",
}) {
  return (
    <section id="upcoming" className="section section-alt">
      <div className="container">
        <h2>Next live AI Lab</h2>

        {isLoading ? <p>Loading upcoming sessions...</p> : null}
        {error ? <p className="status-message error">{error}</p> : null}

        {!isLoading && !error && labs.length === 0 ? (
          <p>
            New date coming soon. Register once now and we'll email you the next
            date, Zoom link, and recording as soon as it's scheduled.
          </p>
        ) : null}

        {!isLoading && !error
          ? labs.map((lab) => (
              <article key={lab.id} className="card lab-card">
                <p className="eyebrow">{formatLabDate(lab.dateTime)}</p>
                <p className="lab-time">
                  {formatLabTimeRange(lab.dateTime, lab.durationMinutes)}
                </p>
                <h3>{lab.title}</h3>
                <p>{lab.shortDescription}</p>

                <div className="action-row">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={onRegisterClick}
                  >
                    {registerButtonLabel}
                  </button>

                  <Link className="text-link-inline" to={`/lab/${lab.id}`}>
                    View details
                  </Link>
                </div>
              </article>
            ))
          : null}
      </div>
    </section>
  );
}

export default UpcomingLabs;
